import { useState } from "react";
import { UserLogged } from "../models/UserLogged.model";
interface Users {
    activeDirectory: boolean;
    apellido: string;
    email: string;
    id: number;
    label: string;
    login: string;
    nombre: string;
    tarjetaEmpresarial: string;
    todosAfiliados: boolean;
    value: string;
  }
  interface UserResult {
      users: Users[]
  }
  
  interface Comercio{
    comercioId : number
    cuit : string
    nombreFantasia : string
    razonSocial : string
  }

const useInitialState = () => {
    const [comercioSelecionado,setComercioSelecionado] = useState([]);
    const [users, setUsers] = useState<UserResult>();
    const [userSelected,setUserSelected] = useState<string>("");
    const [userSessionModulo,setUserSessionModulo] = useState<boolean>(false);
    const [userLogged, setUserLogged] = useState<UserLogged>()
    const [verificarCarga, setVerificarCarga] = useState({"comerciosString":"-1","todos":false});
    const[buscarComercio,setBuscarComercio] = useState(false);
    const [allowedRoutes, setAllowedRoutes] = useState([]);
    const[redirectTo,setRedirectTo] = useState("");
    const [presentacionesIniciadas,setPresentacionesIniciadas] = useState([]);

    return{
        comercioSelecionado,
        setComercioSelecionado,
        users, setUsers,
        userSelected, setUserSelected,
        userSessionModulo,setUserSessionModulo,
        userLogged, setUserLogged,
        verificarCarga, setVerificarCarga,
        buscarComercio,setBuscarComercio,
        allowedRoutes,setAllowedRoutes,
        redirectTo,setRedirectTo,
        presentacionesIniciadas,setPresentacionesIniciadas
    }
}

export default useInitialState